import { SORT_ORDER } from '@witmetrics/utils/constants';

export const DEFAULT_PARAMS = {
  filters: [],
  pagination: { page: 1, pageSize: 100 },
  sorting: { sortBy: 'updatedAt', sortOrder: SORT_ORDER.DESCENDING },
};
